export default function Membership() {
    return (
        <svg className="sidebar-bottom-membership__icon" xmlns="http://www.w3.org/2000/svg" width="16.001" height="21.616" viewBox="0 0 16.001 21.616">
            <path id="Path_377" data-name="Path 377" d="M17,15.245v6.872a.5.5,0,0,1-.757.429L12,20,7.757,22.546A.5.5,0,0,1,7,22.116v-6.87a8,8,0,1,1,10,0ZM9,16.418v3.05l3-1.8,3,1.8v-3.05a8.023,8.023,0,0,1-6,0ZM12,15A6,6,0,1,0,6,9,6,6,0,0,0,12,15Z" transform="translate(-4 -1.001)" fill="#00c8c3"/>
        </svg>
    )
}